module.exports = __webpack_public_path__ + "favorite-star-empty.svg?364835f57319a79a70e3826f1ca28aa8";